/* eslint-disable */
import {
  WorldPayOrderStatus,
  WorldPayPaymentStatus,
  WorldPayResponse,
} from '../models/worldpay.model';

export const mockWorldPay: WorldPayResponse = {
  order: {
    orderKey: 'DGIWEBUK^UKIWRDT3F19092000077',
    status: WorldPayOrderStatus.Success,
  },
  error: null,
  gateway: {
    orderKey: 'DOMGENINSUK^DGIWEBUK^UKIWRDT3F19092000077',
    mac2: 'e2e57ed45465ab2934ddfb419dc2b541b0dbca199fcf0954af9dd4664cd86ef6',
    paymentCurrency: 'GBP',
    paymentAmount: '999',
    paymentStatus: WorldPayPaymentStatus.Authorised,
    mac: '9aab3e8e4470df7c687b2dd422e6d035',
  },
};

export const mockWorldPayFail: WorldPayResponse = {
  order: {
    orderKey: 'DGIWEBUK^UKIWRDT3F19092000077',
  },
  error: null,
  gateway: {
    orderKey: 'DOMGENINSUK^DGIWEBUK^UKIWRDT3F19092000077',
    mac2: 'e2e57ed45465ab2934ddfb419dc2b541b0dbca199fcf0954af9dd4664cd86ef6',
    paymentCurrency: 'GBP',
    paymentAmount: '999',
    paymentStatus: WorldPayPaymentStatus.Refused,
    mac: '9aab3e8e4470df7c687b2dd422e6d035',
  },
};
